import axios from 'axios'

import { PAYMENT_ENCRYPTION_KEY, PAYMENT_SECRET_KEY } from '../constants/encryption'
import { PAYMENT_API_URL } from '../constants/url'
import { encryptData } from '../utils/encrypt'

const token = encryptData(PAYMENT_SECRET_KEY, PAYMENT_ENCRYPTION_KEY)

export const getPaymentAdapterHeaders = (authToken) => {
  return {
    Authorization: authToken || undefined,
    'x-api-key': token
  }
}

const paymentApiInstance = axios.create({
  baseURL: PAYMENT_API_URL,
  timeout: 15000,
  headers: {
    'x-api-key': token
    // 'x-company-key': getPinflagApiKey()
  }
})

paymentApiInstance.interceptors.request.use((config) => {
  const newConfig = config

  newConfig.headers['x-api-key'] = token

  return newConfig
})

export default paymentApiInstance
